<template>
    <div class="dashboard-filters">
        
        <h3>Filtrar por:</h3>

        <div class="select-level">
            <Select 
                label="Nivel"
                :options="levels"
                @select="(item) => (filters.level = item, changeFilter())"
            />
            <!-- <select v-model="filters.level" @change="changeFilter()">
                <option disabled selected value=null>Nivel</option>
                <option v-for="level in levels" :key="level" :value="level">{{ level }}</option>
            </select> -->

        </div>

        <Select
            label="Filial"
            :options="filiales"
            showProp="name"
            @select="(item) => (filters.filial = item?.id || null, changeFilter())"
        />

       <!--  <select v-model="filters.level" @change="changeFilter">
            <option selected :value=null>Nivel</option>
            <option v-for="level in levels" :key="level" :value="level">{{ level || 'Todos' }}</option>
        </select>

        <select v-model="filters.filial" @change="changeFilter">
            <option selected :value=null>Filial</option>
            <option v-for="filial in filiales" :key="filial.id" :value="filial.id">{{ filial.name }}</option>
        </select> -->

    </div>
</template>

<script setup>
import Select from '@/components/Select.vue';
import { ref, defineEmits, defineProps, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
    idFilialesReq: String
})
const emit = defineEmits(['change']);

const filters = ref({
    level: '',
    filial: null
})

function changeFilter(){
    //if(filters.value.level == 'Todos') filters.value.level = ''
    const queryParams = `nivelId=${filters.value.level == 'Todos' ? '' : filters.value.level}&filialId=${filters.value.filial || ''}`
    emit('change', {queryParams, level: filters.value.level == 'Todos' ? null : filters.value.level})
}

const levels = ['Todos', 3, 4, 5]
//const filiales = [{ id:1, name:'filial 1'}, {id:2, name:'filial 2'}]
const filiales = ref([]);

async function getFiliales(){
    let req = await store.dispatch('forgeDash_getFiliales', props.idFilialesReq);
    //filiales.value = req.data;
    filiales.value = [{id: null, name: 'Todos'}, ...req.data]
}

onMounted(()=>{
    getFiliales()
})


</script>

<style lang="scss" scoped>
.dashboard-filters{
    width: 100%;
    padding: 16px 0;
    display: flex;
    align-items: center;
    gap: 36px;
    h3{
        min-width: fit-content;
        font-size: 22px;
        font-weight: 600;
    }
    .select{
        height: 46px;
        max-width: 500px;
    }
    .select-level{
        width: 100%;
        max-width: 200px;
    }
}

    select {
      background: none;
      text-align: left;
      border-top: none;
      border-right: none;
      border-left: none;
      border-bottom: 2px solid $gray;
      height: 40px;
      font-family: $font-opensans;
      color: $gray;
      @include font-settings(milli, xmega);
      width: 100%;

      option {
        color: $litedarkgray;
      }

      &::placeholder {
        color: $graybg;
      }
    }

</style>